import React, { FC } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { HEADPHONES_CHILD, INDIVIDUAL_PLAN, SUCCESS_GUY } from 'assets/images/images';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { HomepageButtonLegacy } from 'src/pages-all/home/components/ActionButton';
import { ImageTile } from '../../../components/tiles/ImageTile';
import { DescriptionTile } from '../../../components/tiles/DescriptionTile';

const Row = styled.div<any>`
  display: ${({ minTablet }) => (minTablet ? 'flex' : 'block')};
  justify-content: center;
  align-items: center;
`;

export const ImageWrapper = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 100%;
  width: 100%;
`;

export const OnlineTutoringAdvantageTiles: FC<{
  tutorspacePlus?: boolean;
  tutorspacePremium?: boolean;
  variant?: 'online-nachhilfe',
}> = ({ tutorspacePlus, tutorspacePremium, variant }) => {
  const { minTablet, maxMobileLarge, minWideDesktop, minDesktop } = useBreakpoints();

  const translation =
    variant === 'online-nachhilfe'
      ? translationKeys.homepage.onlineTutoringAdvantageTilesV2
      : translationKeys.homepage.onlineTutoringAdvantageTiles;

  return (
    <section id={'angebot-elitetutoren'}>
      <MainContent
        style={{ margin: 'auto', padding: minWideDesktop ? '16px 0 0 0' : '16px 16px 0 16px' }}
      >
        <Row minTablet={minWideDesktop}>
          <ImageTile src={SUCCESS_GUY} />
          <DescriptionTile
            minTablet={minTablet}
            maxMobileLarge={maxMobileLarge}
            minDesktop={minDesktop}
            minWideDesktop={minWideDesktop}
            heading={translate(translation.tile1.heading)}
            description={translate(
              translation.tile1.description
            )}
            monoColor
          />
        </Row>
        <Row minTablet={minWideDesktop}>
          {!minWideDesktop && <ImageTile src={INDIVIDUAL_PLAN} />}
          <DescriptionTile
            minTablet={minTablet}
            maxMobileLarge={maxMobileLarge}
            minDesktop={minDesktop}
            minWideDesktop={minWideDesktop}
            heading={translate(translation.tile2.heading)}
            description={translate(
              translation.tile2.description
            )}
            monoColor
          />
          {minWideDesktop && <ImageTile src={INDIVIDUAL_PLAN} />}
        </Row>
        <Row minTablet={minWideDesktop}>
          <ImageTile src={HEADPHONES_CHILD} />
          <DescriptionTile
            minTablet={minTablet}
            maxMobileLarge={maxMobileLarge}
            minDesktop={minDesktop}
            minWideDesktop={minWideDesktop}
            heading={translate(translation.tile3.heading)}
            description={translate(
              translation.tile3.description
            )}
            monoColor
          >
            <HomepageButtonLegacy variant={variant} tutorspacePremium={tutorspacePremium} tutorspacePlus={tutorspacePlus} />
          </DescriptionTile>
        </Row>
      </MainContent>
    </section>
  );
};
